import Box from '@mui/material/Box';
import { ReactElement } from 'react';
import Title from '../components/Title';
import { VariantProps } from './types';

export default function WideVariant({
  name,
  title,
  logo,
}: VariantProps): ReactElement {
  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        gap: { xs: 3, sm: 5 },
        alignItems: { xs: 'center', sm: 'flex-end' },
        pl: 2,
      }}
    >
      <Box
        sx={{
          // border: '2px solid lawngreen',
          height: '100%',
          maxHeight: '450px',
          width: 'auto',
          display: 'flex',
          position: 'relative',
          alignItems: 'flex-end',
          justifyContent: { xs: 'center', sm: 'flex-start' },
        }}
      >
        <Box
          src={logo}
          alt={`logo-${name}`}
          component="img"
          sx={{
            display: 'block',
            // border: '2px solid blue',
            height: '100%',
            objectFit: 'cover',
            // position: 'absolute',
          }}
        />
      </Box>
      <Title
        name={name}
        title={title}
        sx={{
          // border: '2px solid hotpink',
          width: '100%',
        }}
        textAlign={{ xs: 'center', sm: 'right' }}
      />
    </Box>
  );
}
